import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { colors, greys, helpers } from "@clockwise/web-commons/src/styles/color.styles";

const button: CSSProperties = {
  color: greys.white,
  background: colors.blueDusk.standard,
  padding: 4,
  justifyContent: "unset",
  "&:hover": {
    background: helpers.darken(colors.blueDusk.standard, 0.1),
  },
};

const startIcon: CSSProperties = {
  width: 38,
  height: 38,
  background: greys.white,
  margin: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const label: CSSProperties = {
  marginLeft: 20,
};

const logo: CSSProperties = {
  height: 22,
};

export const styles = {
  button,
  startIcon,
  label,
  logo,
};
